import { Option } from '@/common/types';

import { CategoryType } from './EligibleServices.types';

export const CATEGORIES_OPTIONS: Option[] = [
  {
    key: CategoryType.ADOPTION,
    value: CategoryType.ADOPTION,
    title: 'Adoption',
  },
  {
    key: CategoryType.DENTAL,
    value: CategoryType.DENTAL,
    title: 'Dental',
  },
  {
    key: CategoryType.DEPENDENT_CARE,
    value: CategoryType.DEPENDENT_CARE,
    title: 'Dependent care',
  },
  {
    key: CategoryType.MEDICAL,
    value: CategoryType.MEDICAL,
    title: 'Medical',
  },
  {
    key: CategoryType.PARKING,
    value: CategoryType.PARKING,
    title: 'Parking',
  },
  {
    key: CategoryType.PREMIUM,
    value: CategoryType.PREMIUM,
    title: 'Premium',
  },
  {
    key: CategoryType.PHARMACY,
    value: CategoryType.PHARMACY,
    title: 'Pharmacy',
  },
  {
    key: CategoryType.TRANSIT,
    value: CategoryType.TRANSIT,
    title: 'Transit',
  },
  {
    key: CategoryType.VISION,
    value: CategoryType.VISION,
    title: 'Vision',
  },
  {
    key: CategoryType.DEFAULT,
    value: CategoryType.DEFAULT,
    title: 'Default',
  },
  {
    key: CategoryType.WELLNESS,
    value: CategoryType.WELLNESS,
    title: 'Wellness',
  },
  {
    key: CategoryType.TRAVEL,
    value: CategoryType.TRAVEL,
    title: 'Travel',
  },
];

export enum ServiceType {
  MANUAL_CLAIM = 'MANUAL_CLAIM',
  HEALTH_PLAN = 'HEALTH_PLAN',
  CARD = 'CARD',
}

export enum ServiceTypeLabel {
  HEALTH_PLAN = 'Health plan service',
  MANUAL_CLAIM = 'Manual claim service',
  CARD = 'Card service',
}

export const SERVICE_TYPES_OPTIONS: Option[] = [
  {
    key: ServiceType.HEALTH_PLAN,
    value: ServiceTypeLabel.HEALTH_PLAN,
    title: ServiceTypeLabel.HEALTH_PLAN,
  },
  {
    key: ServiceType.MANUAL_CLAIM,
    value: ServiceTypeLabel.MANUAL_CLAIM,
    title: ServiceTypeLabel.MANUAL_CLAIM,
  },
  {
    key: ServiceType.CARD,
    value: ServiceTypeLabel.CARD,
    title: ServiceTypeLabel.CARD,
  },
];
